const userState = {
  state: () => ({
    role: null,
  }),
  mutations: {
    setRole(state, values = {}) {
      state.role = values;
    },
  },
};

export default userState;



// WEBPACK FOOTER //
// ./src/_shared/store/user.js